import { defineStore } from 'pinia';
import stores from '🔗/stores';

const useMessagesStore = defineStore('message', {
    state: () => ({
        messages: []
    }),
    actions: {
        setMessages(message) {
            this.messages.push(message)
            const timerId = setTimeout(() => {
                const idx = this.messages.findIndex((el) => el.id === message.config.id);
                this.messages.splice(idx, 1);
                clearTimeout(timerId);
            }, message.config.delay);


            if (stores.settings().vibration) {
                stores.others().vibrate({
                    info: 'warning',
                    success: 'success',
                    error: 'error'
                }[message.type] || 'light');
            }
        }
    }
});

export default useMessagesStore;